import { ChangeDetectionStrategy, Component, ViewChild, AfterViewInit, OnInit } from '@angular/core';
import {RoleService} from 'app/core/service/role.service';
import {Role} from 'app/core/domain/role';
import {Subject} from 'rxjs/Subject';
import {Router} from '@angular/router';
import {ConfirmationService} from 'primeng/components/common/api';
import {GlobalAppService} from 'app/core/commons/global-app.service';
import {MessageSeverity} from '../../../core/commons/message-severity';
import {Observable} from 'rxjs/Observable';
import {MatPaginator, MatTableDataSource, MatSort} from '@angular/material';
import { QueryOptions } from '../../../core/commons/query.options';

@Component({
    selector: 'app-role-list',
    templateUrl: './role-list.component.html',
    styleUrls: ['./role-list.component.scss'],
    providers: [RoleService],
    // changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoleListComponent implements OnInit {

  dataSource: MatTableDataSource<Role> = new MatTableDataSource<Role>();
  rolesData: any = {};
  queryOptions: QueryOptions;
  resultsLength: number;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns = ['id', 'name', 'actions'];
 
  

    constructor(private roleService: RoleService,
                private confirmationService: ConfirmationService,
                private appService: GlobalAppService,
                private router: Router) {
    }

    ngOnInit(){
        this.queryOptions = new QueryOptions();
        this.queryOptions.size = 5;
        this.getPage();

        this.paginator.page.subscribe(() => {
            this.queryOptions.page = this.paginator.pageIndex;
            this.queryOptions.size = this.paginator.pageSize;
           
            this.getPage();
          });
    }

    getPage(){
            this.roleService
              .getPage(this.queryOptions)
              .subscribe(data => {
                this.rolesData = data;
                this.dataSource.data = this.rolesData.content;
                this.resultsLength = this.rolesData.totalElements;
              });
    
    }

  

    public gotoDetail(role: Role) {
        this.router.navigate(['home', 'role', role.id]);
    }

    public addRol() {
        this.router.navigate(['home', 'role', 'new']);
    }

    deleteRole(role: Role) {
      this.confirmationService.confirm({
          message: '¿está seguro que desea eliminar el rol?',
          icon: 'fa ui-icon-delete-forever',
          accept: () => {
              this.roleService.delete(role)
                  .subscribe(() => {
                     // this.reload.next(true);
                      this.appService.sendMsg(
                          MessageSeverity.SUCCESS,
                          'Exito!', 'El rol fue eliminado correctamente.')
                  }, error => {
                      this.appService.sendMsg(
                          MessageSeverity.ERROR,
                          'Error',
                          'No ha sido posible eliminar el rol. ' + error.json().message)
                  });
          }
      });
  }

  /* public deleteRol(role: Role) {
        this.confirmationService.confirm({
            message: '¿está seguro que desea eliminar el rol?',
            icon: 'fa ui-icon-delete-forever',
            accept: () => {
                this.roleService.delete(role)
                    .subscribe(res => {
                        this.appService.sendMsg(MessageSeverity.SUCCESS, 'Exito!', 'El rol fue eliminado correctamente.');
                        this.rolesList.some(function (value, index, roles) {

                            if (value.id === role.id) {
                                roles.splice(index, 1);
                            }

                            return value.id === role.id;
                        });
                    });
                this.roles.next(this.rolesList);
            }
        });
    */
      }
    



// WEBPACK FOOTER //
// ./src/app/admin/roles/role-list/role-list.component.ts